module.exports = __webpack_public_path__ + "static/img/zgyc.bc764e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/zgyc.png
// module id = 70DD
// module chunks = 13